import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getUsersForDropDown } from '../../Users/redux/userActions'
import { setContact, getDuplicatedContacts, createContact } from '../redux/ContactActions'
import PropTypes from 'prop-types'
import { Row, Col, Button } from 'reactstrap'
import CustomSelect from '../../../common/CustomReactSelectComponent'
import CustomInputGroup from '../../../common/InputGroup'
import CustomNumberFormat from '../../../common/CustomNumberFormat'
import CustomRadioButton from '../../../common/CustomRadioButton'
import CustomToast from './CustomToast'
import Loader from '../../Loader'
import { notificationSuccess } from '../../../utils/customToastify'
import axios from 'axios'

class SelectUserToAssigne extends Component {
  state = {
    data: {},
    isTostOpen: false,
    organizationOptions: [],
    allOptions: [],
    radioValue: '',
    loading: false,
  }

  async componentDidMount() {
    this.setState({ loading: true })
    const { isIncomingCallNewContact, phoneNumber } = this.props
    if (isIncomingCallNewContact && phoneNumber) {
      this.setState((prev) => ({ ...prev, data: { ...prev.data, businessPhone: phoneNumber } }))
    }
    const resOptions = await this.loadOrganizationTypes()
    this.setState((prev) => ({ ...prev, allOptions: resOptions.data, loading: false }))
  }

  onOrganizationTypeChange = (e) => {
    const { id: organizationType } = e
    this.setState((prev) => ({ ...prev, organizationType }))
  }
  handleChange = (e) => {
    const { value, name } = e.target
    this.setState((state) => {
      return {
        ...state,
        data: { ...state.data, [name]: value },
        error: {},
      }
    })
  }

  createContact = async () => {
    const { data, organizationType } = this.state
    const { isIncomingCallNewContact, callback, toggleModal } = this.props
    const res = await this.props.createContact({ ...data, organizationTypeId: organizationType })
    if (!isIncomingCallNewContact) {
      this.props.history.push(`/contacts/${res[0].id}`)
    } else {
      if (callback && typeof callback === 'function') {
        //re-fetch contacts for given call
        await callback()
        //close duplicate contacts toast
        this.toggleToast()
        if (toggleModal && typeof toggleModal === 'function') {
          //close add new contact modal
          toggleModal()
        }
      }
    }
    notificationSuccess('Contact created!')
    if (res?.data) {
      window.open(`/contacts/${res[0].id}`, '_blank')
    }
  }

  saveContact = async () => {
    try {
      this.setState({ loading: true })
      const { data, organizationType } = this.state
      const { getDuplicatedContacts, setContact } = this.props
      if (!data.name || data.name === '') {
        this.setState({ error: { name: 'Please add name' }, loading: false })
        return
      }
      setContact({ ...data, organizationTypeId: organizationType })
      const response = await getDuplicatedContacts({ filter: data })

      if (!response.length) {
        await this.createContact()
      }
      if (response.length) {
        this.toggleToast()
      }
      this.setState({ loading: false })
    } catch (err) {
      this.setState({ loading: false })
    }
  }

  toggleToast = () => {
    this.setState((state) => {
      return {
        ...state,
        isTostOpen: !state.isTostOpen,
      }
    })
  }

  loadOrganizationTypes = async () => {
    const ORGANIZATION_TYPES = 2
    const response = await axios.get(`/support-tables`, {
      params: { tableFilter: { support_type_id: ORGANIZATION_TYPES } },
    })
    return response.data
  }

  handleRadioButtonChange = async (e) => {
    const { value } = e.currentTarget
    const selectedOptions = []
    this.state.allOptions.forEach((i) => {
      if (value === 'individual') {
        if (i.name === 'Company Driver' || i.name === 'Owner Operator' || i.name === 'Contractor') {
          selectedOptions.push({ name: i.name, id: i.id })
        }
      }
      if (value === 'business') {
        if (i.name === 'Motor Carrier' || i.name === 'Private Fleet') {
          selectedOptions.push({ name: i.name, id: i.id })
        }
      }
    })
    this.setState((state) => {
      return {
        ...state,
        organizationOptions: selectedOptions,
        radioValue: value,
      }
    })
  }

  handleBackButtonClick = () => {
    const { isIncomingCallNewContact, phoneNumber } = this.props
    let data = {}
    if (isIncomingCallNewContact && phoneNumber) {
      data = { businessPhone: phoneNumber }
    }
    this.setState({ organizationType: undefined, data })
  }

  render() {
    const { organizationType, data, isTostOpen, error, organizationOptions, radioValue, loading } = this.state
    const { duplicatedContacts } = this.props
    const MOTOR_CARRIER = 7
    const PRIVATE_FLEET = 3

    let loader = null
    if (loading) loader = <Loader />

    const contactFields = (organizationType) => {
      return (
        <>
          <Row className='text-center mx-auto w-50'>
            {loader}
            <Col xs={12} className='mt-2'>
              <CustomInputGroup
                onChange={this.handleChange}
                name='name'
                label='Name'
                value={data.name}
                placeholder='Name'
                type='text'
                invalid={error && error.name}
                errorMess={error && error.name}
              />
            </Col>
            {organizationType !== MOTOR_CARRIER && organizationType !== PRIVATE_FLEET && (
              <Col xs={12} className='mt-2'>
                <CustomNumberFormat
                  className={'form-control-sm form-control'}
                  name='businessPhone'
                  value={data.businessPhone}
                  placeholder='Phone Number'
                  label='Phone Number'
                  type='tel'
                  format='(999) 999-9999'
                  onChange={(e) => this.handleChange(e)}
                  size={10}
                />
              </Col>
            )}

            {organizationType === PRIVATE_FLEET && (
              <Col xs={12} className='mt-2'>
                <CustomInputGroup
                  onChange={this.handleChange}
                  name='dotNumber'
                  label='DOT Number'
                  value={data.dotNumber}
                  placeholder='DOT Number'
                  type='text'
                />
              </Col>
            )}
            {organizationType === MOTOR_CARRIER && (
              <Col xs={12} className='mt-2'>
                <CustomInputGroup
                  onChange={this.handleChange}
                  name='mcNumber'
                  label='MC Number'
                  value={data.mcNumber}
                  placeholder='MC Number'
                  type='text'
                />
              </Col>
            )}
          </Row>
          <Row className='mt-3'>
            <Col xs={6}>
              <Button className='btn btn-gold' onClick={this.handleBackButtonClick}>
                Back
              </Button>
            </Col>
            <Col xs={6}>
              <Button className='btn btn-gold float-right' onClick={this.saveContact}>
                Save
              </Button>
            </Col>
          </Row>
        </>
      )
    }
    return (
      <>
        {duplicatedContacts && (
          <CustomToast isTostOpen={isTostOpen} toggleToast={this.toggleToast} addNewContact={this.createContact} />
        )}
        {organizationType ? (
          contactFields(organizationType)
        ) : (
          <>
            <Row className='mt-3 mx-auto text-center w-50'>
              <span className='mx-auto'>Contact Type</span>
            </Row>
            <Row className='mt-3 mx-auto text-center w-50'>
              {loader}
              <Col>
                <div>
                  <CustomRadioButton
                    onChange={this.handleRadioButtonChange}
                    name='individual'
                    checked={radioValue === 'individual'}
                    value='individual'
                    label='Individual'
                  />
                </div>
              </Col>
              <Col>
                <div>
                  <CustomRadioButton
                    onChange={this.handleRadioButtonChange}
                    label='Business'
                    checked={radioValue === 'business'}
                    name='individual'
                    value='business'
                  />
                </div>
              </Col>
            </Row>
            <Row className='mt-5 mx-auto text-center w-50'>
              <Col>
                <CustomSelect
                  isMulti={false}
                  placeholder='Please select'
                  label='Organization Type'
                  onChange={this.onOrganizationTypeChange}
                  options={organizationOptions}
                  selected={organizationType}
                />
              </Col>
            </Row>
          </>
        )}
      </>
    )
  }
}

SelectUserToAssigne.propTypes = {
  history: PropTypes.object.isRequired,
  users: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  getUsersForDropDown: PropTypes.func.isRequired,
  selectedRows: PropTypes.array.isRequired,
  assignUser: PropTypes.func.isRequired,
  loadData: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return {
    users: state.users.usersForDropDown,
    divisionId: state.auth.user.division_id,
    duplicatedContacts: state.contacts.duplicatedContacts,
  }
}

export default connect(mapStateToProps, {
  getUsersForDropDown,
  setContact,
  getDuplicatedContacts,
  createContact,
})(SelectUserToAssigne)
